import React from "react";
import {useRenderPercentValue} from "../../api/utilities/useValueRenderers.js";

export default function OverviewValue({title, value, percentChange, last, titleSize = '3xl'}) {
    let renderPercentValue = useRenderPercentValue();

    let percentChangeTextClass = 'text-green-700 bg-green-500/20';

    if (percentChange < 0) {
        percentChangeTextClass = 'text-datixo-negative bg-red-500/20';
    } else if (percentChange < 5) {
        percentChangeTextClass = 'text-black bg-gray-500/20';
    }

    return <div className="flex items-center py-2">
        <div className="mr-5">
            <div className="text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase mb-1">
                <div className="flex items-center gap-2">
                {title}
                {percentChange !== undefined && <div className={"text-xs font-medium px-1.5 rounded-full " + percentChangeTextClass}>
                    {renderPercentValue(percentChange)}
                </div>}
                </div>
            </div>
            <div className={`text-${titleSize} font-bold text-gray-800 dark:text-gray-100 mr-2`}>{value}</div>
        </div>
        {last !== true && <div
            className="hidden md:block w-px h-8 bg-slate-200 dark:bg-slate-700 mr-5"
            aria-hidden="true"
        ></div>}
    </div>;
}